import { MessagingChannel } from 'jschannel';
import { StatementOptions, VERB_ID } from '@/components/C1Opener/OpenerTypes';
import { sendMessageToContainer } from '@/components/C1Opener/SendMessageUtils';

export async function sendConsumedStatement(
    channel: MessagingChannel,
    contentId: string,
    options?: StatementOptions
): Promise<unknown> {
    const verbId = options?.verbId ?? VERB_ID;
    return sendMessageToContainer(channel, 'newStatements', [
        {
            verb: {
                id: `${verbId}/consume`,
                display: {
                    und: 'consumed'
                }
            },
            object: {
                id: `${contentId}/warmup`
            }
        }
    ]);
}